import styled, { css, keyframes } from "styled-components";

interface IContent {
  loading?: boolean;
}

export const Content = styled.div<IContent>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};

  .containerReload {
    position: absolute;
    height: 32px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .btnReload {
      height: 32px !important;
      width: 163px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 32px !important;
  
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
  
      .iconDownArrow {
        color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
      }
    }
  }

  ${({ loading }) => loading && css`
    max-height: 380px;
    overflow: hidden;
  `}
`;

export const DataBadgeContainer = styled.span`
  position: absolute;
  top: 6px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .badgeText {
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    border-radius: 999px;

    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant};
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`;

interface IRemovingCard {
  removing?: boolean;
}

export const RemovingCard = styled.div<IRemovingCard>`
  ${({ removing }) => removing && css`
    animation: ${fadeOut} 0.8s forwards;
  `}
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
`;
